export default __webpack_public_path__ + "static/md-tagged-list-98250add4d20576f6fd1eab734478cf5.mp4";